import React, { Dispatch, SetStateAction } from 'react';
import { MdOutlineBarChart, MdOutlineFormatListBulleted } from 'react-icons/md';
import { TypeReport } from '../../types';
import Option from './Option';

import { Container, Label } from './styles';

type ViewModeFilterProps = {
  typeReport: TypeReport;
  setTypeReport: Dispatch<SetStateAction<TypeReport>>;
};

const ViewModeFilter: React.FC<ViewModeFilterProps> = ({
  typeReport,
  setTypeReport,
}) => {
  return (
    <Container>
      <Label>Modo de visualização:</Label>
      <Option
        isCheck={typeReport === 'graph'}
        Icon={MdOutlineBarChart}
        onClick={() => setTypeReport('graph')}
      />
      <Option
        isCheck={typeReport === 'list'}
        Icon={MdOutlineFormatListBulleted}
        onClick={() => setTypeReport('list')}
      />
    </Container>
  );
};

export default ViewModeFilter;
